"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prettyPrintAllFormulas = exports.prettyPrintFormula = exports.isValidFormulaSyntax = exports.inspectDependencies = void 0;
const lodash_1 = __importDefault(require("lodash"));
const formula_engine_1 = require("@finley-technologies/formula-engine");
var formula_engine_2 = require("@finley-technologies/formula-engine");
Object.defineProperty(exports, "inspectDependencies", { enumerable: true, get: function () { return formula_engine_2.inspectDependencies; } });
/**
 * checks given formula for syntax and function references.
 * @param formula
 * @returns {IsValid} type with validity, and errorMessages.
 *   This function only checks for the syntax and function references.
 *   It does not validate variables in the formula.
 */
const isValidFormulaSyntax = (formula) => {
    const { errorMessages } = (0, formula_engine_1.getFormulaErrors)(formula);
    return {
        isValid: errorMessages.length === 0,
        errorMessages,
    };
};
exports.isValidFormulaSyntax = isValidFormulaSyntax;
const prettyPrintFormula = (formula) => {
    return (0, formula_engine_1.prettyFormula)(formula);
};
exports.prettyPrintFormula = prettyPrintFormula;
/**
 * Prettifies any "formula" properties within the provided obj. Returns a transformed copy, does not edit in place.
 * @param obj Original object that has a "formula" property or nested property
 * @returns Obj
 */
const prettyPrintAllFormulas = (obj) => {
    const newObj = lodash_1.default.cloneDeep(obj);
    function prettyPrintTheFormulas(_obj) {
        for (const key in _obj) {
            if (Object.prototype.hasOwnProperty.call(_obj, key)) {
                if (key === 'formula' && lodash_1.default.isString(_obj[key])) {
                    const prettifiedFormula = (0, exports.prettyPrintFormula)(_obj[key]);
                    /* eslint-disable no-param-reassign */
                    _obj[key] = prettifiedFormula;
                }
                if (typeof _obj[key] === 'object' && _obj[key] !== null) {
                    prettyPrintTheFormulas(_obj[key]);
                }
            }
        }
    }
    prettyPrintTheFormulas(newObj);
    return newObj;
};
exports.prettyPrintAllFormulas = prettyPrintAllFormulas;
//# sourceMappingURL=formulaHelpers.js.map